var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"btn btn-pill btn-xs",attrs:{"id":"export-csv-whitlist-btn-z","size":"sm","variant":"primary","disabled":_vm.btnExport},on:{"click":_vm.getExport}},[_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-file-export"}}),_vm._v(" Export ")],1),_c('exportCSV',{ref:"exportdata"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }